import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ModelVendorManagement from '../../components/admin/ModelVendorManagement';

const ModelVendorManagementPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="p-6">
        <ModelVendorManagement />
      </div>
    </AdminLayout>
  );
};

export default ModelVendorManagementPage;